import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';
import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-field-ok-artstamm-detail-view',
  imports: [CommonModule, UiCoreModule],
  templateUrl: './artstamm.detail-view.html',
  styleUrls: ['./artstamm.detail-view.css'],
})
export class ArtstammDetailView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
